import { Footer as GrommetFooter, Box, Text, Image, Anchor, ResponsiveContext } from 'grommet';
import React, { useContext } from 'react';
import { LinkedinOption, Instagram } from 'grommet-icons';

import '../website/styles/styles.css'
import appStoreButton from '../assets/images/app-store-button.png'
import googleStoreButton from '../assets/images/google-play-button.png'

const Footer = () => {
  const size = useContext(ResponsiveContext);
  const horizontalPad = size === 'small' ? 'large' : 'xlarge';

  return (
    <Box
      background="#000"
      pad={{ vertical: 'large', horizontal: horizontalPad }}
      direction='column'
    >
      {/* Logo */}
      <Box direction="row" align="center" gap="small" margin={{ bottom: 'large' }}>
        <Box width="5rem">
          <Image src="/Picture3 - Transparent.png" alt="Bins Storage valet storage logo" />
        </Box>
      </Box>

      {/* 4-column link section */}
      <GrommetFooter direction="row-responsive" justify="between" wrap={true} align='start' margin={{ bottom: 'large' }} gap="large">

        {/* Column 1 – Company */}
        <Box align="start" gap="xsmall">
          <Text className='ralewaySmall' margin={{ bottom: 'xsmall' }}>COMPANY</Text>
          <Anchor href="/About"><Text color="#FFF" className="link">About</Text></Anchor>
          <Anchor href="/Partners"><Text color="#FFF" className="link">Partners</Text></Anchor>
          <Anchor href="/blog"><Text color="#FFF" className="link">Blog</Text></Anchor>
          <Anchor href="/Contact"><Text color="#FFF" className="link">Contact Us</Text></Anchor>
        </Box>

        {/* Column 2 – Customers */}
        <Box align="start" gap="xsmall">
          <Text className='ralewaySmall' margin={{ bottom: 'xsmall' }}>CUSTOMERS</Text>
          <Anchor href="/FAQ"><Text color="#FFF" className="link">FAQ</Text></Anchor>
          <Anchor href="/Download"><Text color="#FFF" className="link">Reserve Now</Text></Anchor>
          <Anchor href="/Download"><Text color="#FFF" className="link">Pricing &amp; Unit Sizes</Text></Anchor>
          <Box direction="row" gap="small" margin={{ top: 'small' }}>
            <Anchor href="https://apps.apple.com/us/app/bins-storage/id1554718615">
              <Image className="appStoreButton" src={appStoreButton} alt="Download on the App Store" />
            </Anchor>
            <Anchor href="https://play.google.com/store/apps/details?id=com.BinsStorage.TenantApp">
              <Image className="appStoreButton" src={googleStoreButton} alt="Get it on Google Play" />
            </Anchor>
          </Box>
        </Box>

        {/* Column 3 – Locations */}
        <Box align="start" gap="xsmall">
          <Text className='ralewaySmall' margin={{ bottom: 'xsmall' }}>LOCATIONS</Text>
          <Anchor href="/san-francisco"><Text color="#FFF" className="link">San Francisco Bay Area</Text></Anchor>
          <Anchor href="/tacoma"><Text color="#FFF" className="link">Tacoma, WA</Text></Anchor>
        </Box>

        {/* Column 4 – Legal & Support */}
        <Box align="start" gap="xsmall">
          <Text className='ralewaySmall' margin={{ bottom: 'xsmall' }}>SUPPORT &amp; LEGAL</Text>
          <Anchor href="/support"><Text color="#FFF" className="link">Support</Text></Anchor>
          <Anchor href="/privacy"><Text color="#FFF" className="link">Privacy Policy</Text></Anchor>
          <Anchor href="/terms"><Text color="#FFF" className="link">Terms of Service</Text></Anchor>
          <Anchor href="/Tenant"><Text color="#FFF" className="link">Tenant Portal</Text></Anchor>
          <Anchor href="/Admin"><Text color="#FFF" className="link">Admin Portal</Text></Anchor>
        </Box>

      </GrommetFooter>

      {/* Bottom row: copyright + social */}
      <Box
        direction="row"
        justify="between"
        align="center"
        border={{ color: 'rgba(255,255,255,0.1)', side: 'top' }}
        pad={{ top: 'medium' }}
      >
        <Text className="ralewayNoMargin">© 2026 Bins Storage, Inc. All rights reserved.</Text>
        <Box direction="row" gap="none">
          <Anchor
            href="https://www.instagram.com/bins.storage/"
            icon={<Instagram color="#FFF" />}
            a11yTitle="Follow Bins Storage on Instagram"
          />
          <Anchor
            href="https://www.linkedin.com/company/bins-storage"
            icon={<LinkedinOption color="#FFF" />}
            a11yTitle="Bins Storage on LinkedIn"
          />
        </Box>
      </Box>

    </Box>
  );
};

export default Footer;
